import { ButtonTertiary } from "../ButtonTertiary/index.js";
import styled from "../../styled-components.js";
export var CloseButton = styled(ButtonTertiary).withConfig({
  displayName: "CloseButton",
  componentId: "sc-i2fggp-0"
})(["position:absolute;inset-block-start:4px;inset-inline-end:4px;"]);